<template>
  <div class="loading">
    <div class="child bounce1" :style="{ backgroundColor: color ? color : '#B0C3D5' }"></div>
    <div class="child bounce2":style="{ backgroundColor: color ? color : '#B0C3D5' }"></div>
    <div class="child bounce3":style="{ backgroundColor: color ? color : '#B0C3D5' }"></div>
  </div>
</template>


<script>
  import API from 'mixins/api';

  export default {
    props: ['color']
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .loading {
    margin: 300px auto 0;
    width: 80px;
    text-align: center;
    .child {
      width: 20px;
      height: 20px;
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: loading 1.4s ease-in-out 0s infinite both;
              animation: loading 1.4s ease-in-out 0s infinite both;
    }
    .bounce1 {
      -webkit-animation-delay: -0.32s;
              animation-delay: -0.32s;
    }
    .bounce2 {
      -webkit-animation-delay: -0.16s;
              animation-delay: -0.16s;
    }
  }

  @-webkit-keyframes loading {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
              transform: scale(0); }
    40% {
      -webkit-transform: scale(1);
              transform: scale(1); } }

  @keyframes loading {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
              transform: scale(0); }
    40% {
      -webkit-transform: scale(1);
              transform: scale(1); } }
</style>



// WEBPACK FOOTER //
// loading-indicator.vue?6d4406e4